<div class="page-layout">
  <app-toast></app-toast>

  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar
      pageTitle="Code Graph"
      pageSubtitle="Structural graph generated from the repository source (files, classes, functions)."
    ></app-navbar>

    <div class="content">
      <div class="graph-card">
        <div class="card-header">
          <div class="header-left">
            <button type="button" class="back-btn" (click)="goBack()">&larr; {{ cameFromClassification() ? 'Classification' : 'Repositories' }}</button>
            <h3 class="card-title">{{ repoName() || 'Combined Graph' }}</h3>
          </div>
        </div>

        <div class="graph-body">
          <div class="loading-overlay" *ngIf="isLoadingGraph()">
            <div class="spinner"></div>
          </div>

          <div class="empty-overlay" *ngIf="!isLoadingGraph() && nodeCount() === 0">
            <h2 class="empty-title">No Graph Data Yet</h2>
            <p class="empty-text">This repository hasn't been extracted into the code graph yet.</p>
          </div>

          <div class="graph-stage">
            <div #graphCanvas class="graph-canvas"></div>

            <div class="legend">
              <div class="legend-item"><span class="legend-dot file"></span> File / Repository</div>
              <div class="legend-item"><span class="legend-dot class"></span> Class / Interface</div>
              <div class="legend-item"><span class="legend-dot function"></span> Function / Module</div>
              <div class="legend-item"><span class="legend-line"></span> Relationship</div>
            </div>

            <div class="layout-controls">
              <span class="layout-label">Layout</span>
              <button type="button" class="layout-btn"
                      *ngFor="let layout of availableLayouts"
                      [class.active]="currentLayout() === layout"
                      (click)="applyLayout(layout)">
                {{ layout }}
              </button>
            </div>

            <div class="graph-toolbar">
              <span class="graph-stats">
                {{ nodeCount() }} nodes · {{ edgeCount() }} edges
                <span class="streaming-dot" *ngIf="isStreamingMore()" title="Loading more…"></span>
              </span>
              <button type="button" class="toolbar-btn" (click)="resetView()">Reset View</button>
            </div>
          </div>

          <aside class="details-panel" [class.hidden]="!selectedType()">
            <ng-container *ngIf="selectedType(); else detailsHintTpl">
              <span class="detail-kind">{{ selectedType() === 'node' ? 'Node' : 'Edge' }}</span>
              <h4 class="detail-title">{{ selectedTitle() }}</h4>
              <p class="detail-subtitle">{{ selectedSubtitle() }}</p>

              <div class="detail-row" *ngFor="let item of selectedMeta()">
                <span class="detail-label">{{ item.label }}</span>
                <span class="detail-value">{{ item.value }}</span>
              </div>
            </ng-container>
          </aside>
        </div>
      </div>
    </div>
  </div>

  <ng-template #detailsHintTpl>
    <div class="details-hint">
      Click a node or edge to inspect details.
    </div>
  </ng-template>
</div>
